package dev.wyns.ventrova.ui.cupertino

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import dev.wyns.ventrova.app.AppMessage
import dev.wyns.ventrova.app.PlaceItem
import dev.wyns.ventrova.app.RadiusOptions
import dev.wyns.ventrova.data.model.MenuItem
import dev.wyns.ventrova.data.model.PlaceCategory
import dev.wyns.ventrova.data.model.VeganLevel
import dev.wyns.ventrova.platform.displayUrl
import dev.wyns.ventrova.resources.Res
import dev.wyns.ventrova.resources.action_call
import dev.wyns.ventrova.resources.action_route
import dev.wyns.ventrova.resources.action_save
import dev.wyns.ventrova.resources.action_website
import dev.wyns.ventrova.resources.filter_distance
import dev.wyns.ventrova.resources.filter_how_plant_based
import dev.wyns.ventrova.resources.filter_kind_of_place
import dev.wyns.ventrova.resources.filter_open_now
import dev.wyns.ventrova.resources.filter_show_places
import dev.wyns.ventrova.resources.ic_call_filled
import dev.wyns.ventrova.resources.ic_check
import dev.wyns.ventrova.resources.ic_check_circle_filled
import dev.wyns.ventrova.resources.ic_circle
import dev.wyns.ventrova.resources.ic_directions_filled
import dev.wyns.ventrova.resources.ic_expand_less
import dev.wyns.ventrova.resources.ic_expand_more
import dev.wyns.ventrova.resources.ic_favorite
import dev.wyns.ventrova.resources.ic_favorite_filled
import dev.wyns.ventrova.resources.ic_language
import dev.wyns.ventrova.resources.ic_location_on
import dev.wyns.ventrova.resources.ic_schedule
import dev.wyns.ventrova.resources.opening_hours
import dev.wyns.ventrova.resources.opening_hours_today
import dev.wyns.ventrova.resources.report_action
import dev.wyns.ventrova.resources.report_question
import dev.wyns.ventrova.resources.suggest_address
import dev.wyns.ventrova.resources.suggest_done
import dev.wyns.ventrova.resources.suggest_error
import dev.wyns.ventrova.resources.suggest_name
import dev.wyns.ventrova.resources.suggest_note_placeholder
import dev.wyns.ventrova.resources.suggest_thanks
import dev.wyns.ventrova.resources.suggest_thanks_body
import dev.wyns.ventrova.resources.suggest_what_is_vegan
import dev.wyns.ventrova.resources.walk_minutes_long
import dev.wyns.ventrova.ui.components.FryOilBanner
import dev.wyns.ventrova.ui.components.LevelBanner
import dev.wyns.ventrova.ui.components.LevelGlyph
import dev.wyns.ventrova.ui.components.LocalPlatformControls
import dev.wyns.ventrova.ui.components.MenuDishes
import dev.wyns.ventrova.ui.components.MenuStyle
import dev.wyns.ventrova.ui.components.PlaceThumbnail
import dev.wyns.ventrova.ui.components.StrictnessSlider
import dev.wyns.ventrova.ui.components.VIcon
import dev.wyns.ventrova.ui.components.WeekHours
import dev.wyns.ventrova.ui.components.bodyStyle
import dev.wyns.ventrova.ui.components.cuisineLabel
import dev.wyns.ventrova.ui.components.menuTitle
import dev.wyns.ventrova.ui.components.radiusLabel
import dev.wyns.ventrova.ui.components.stopDescription
import dev.wyns.ventrova.ui.theme.LevelPalettes
import dev.wyns.ventrova.ui.theme.VentrovaColors
import dev.wyns.ventrova.ui.theme.currentDayOfWeek
import dev.wyns.ventrova.ui.theme.description
import dev.wyns.ventrova.ui.theme.displayStyle
import dev.wyns.ventrova.ui.theme.distanceLabel
import dev.wyns.ventrova.ui.theme.hoursOnDay
import dev.wyns.ventrova.ui.theme.icon
import dev.wyns.ventrova.ui.theme.label
import dev.wyns.ventrova.ui.theme.openStatusText
import dev.wyns.ventrova.ui.theme.palette
import kotlin.math.roundToInt
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource

/** Body of the place detail sheet; the close and favorite buttons are native bar buttons. */
@Composable
internal fun CupertinoDetailContent(model: CupertinoModel) {
    CupertinoTheme(model) {
        val state by model.viewModel.state.collectAsState()
        val item = state.detail ?: return@CupertinoTheme
        CupertinoDetail(item, state.detailMenu, model)
    }
}

@Composable
private fun CupertinoDetail(item: PlaceItem, menu: List<MenuItem>?, model: CupertinoModel) {
    val place = item.place
    val actions = model.dependencies.externalActions
    var hoursOpen by remember(item.id) { mutableStateOf(false) }
    Column(Modifier.fillMaxSize().background(VentrovaColors.Paper).verticalScroll(rememberScrollState()).padding(bottom = 48.dp)) {
        PlaceThumbnail(place, Modifier.fillMaxWidth().height(170.dp), RoundedCornerShape(0.dp), iconSize = 44.dp)
        // Lets the name, address, hours and dishes be selected and copied.
        SelectionContainer {
            Column(Modifier.padding(start = 20.dp, end = 20.dp, top = 18.dp)) {
                Text(listOfNotNull(stringResource(place.category.label), place.cuisineLabel()).joinToString(" · "), style = bodyStyle(14.sp, color = VentrovaColors.Muted))
                Text(place.name, style = displayStyle(31, lineHeight = 1.05f), modifier = Modifier.padding(top = 4.dp))
                LevelBanner(place.veganLevel, Modifier.padding(top = 12.dp).fillMaxWidth())
                FryOilBanner(place, onReport = { model.viewModel.requestFryOilCheck(place.id) }, modifier = Modifier.padding(top = 8.dp).fillMaxWidth())
                val status = openStatusText(item.openStatus)
                val distance = item.distanceMeters
                if (status != null || distance != null) {
                    Text(
                        buildAnnotatedString {
                            if (status != null) {
                                withStyle(SpanStyle(color = status.color, fontWeight = FontWeight.SemiBold)) { append(status.status) }
                                status.change?.let { append(" · $it") }
                            }
                            if (distance != null) {
                                if (status != null) append("    ")
                                append(distanceLabel(distance) + " · " + stringResource(Res.string.walk_minutes_long, (distance / 1000 * 13).roundToInt().coerceAtLeast(1)))
                            }
                        },
                        style = bodyStyle(14.5.sp, color = VentrovaColors.Secondary),
                        modifier = Modifier.padding(top = 10.dp),
                    )
                }
                DisableSelection {
                    Row(Modifier.padding(top = 16.dp), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        ActionTile(Res.drawable.ic_directions_filled, stringResource(Res.string.action_route), dark = true, modifier = Modifier.weight(1f)) { actions.openDirections(place) }
                        ActionTile(Res.drawable.ic_call_filled, stringResource(Res.string.action_call), enabled = place.phone != null, modifier = Modifier.weight(1f)) { place.phone?.let(actions::call) }
                        ActionTile(Res.drawable.ic_language, stringResource(Res.string.action_website), enabled = place.website != null, modifier = Modifier.weight(1f)) { place.website?.let(actions::openWebsite) }
                        ActionTile(
                            if (item.isFavorite) Res.drawable.ic_favorite_filled else Res.drawable.ic_favorite,
                            stringResource(Res.string.action_save),
                            iconTint = if (item.isFavorite) VentrovaColors.Favorite else VentrovaColors.Ink,
                            modifier = Modifier.weight(1f),
                        ) { model.viewModel.toggleFavorite(item.id) }
                    }
                }

                if (place.menu != null) {
                    Text(menuTitle(place), style = displayStyle(21, lineHeight = 1.1f), modifier = Modifier.padding(top = 28.dp, bottom = 8.dp))
                    MenuDishes(place, menu, MenuStyle.Ios)
                }

                place.openingHours?.let { hours ->
                    val today = currentDayOfWeek()
                    Row(
                        Modifier.padding(top = 22.dp).fillMaxWidth().clip(RoundedCornerShape(18.dp)).background(Color.White).clickable { hoursOpen = !hoursOpen }.padding(horizontal = 16.dp, vertical = 14.dp),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(12.dp),
                    ) {
                        VIcon(Res.drawable.ic_schedule, size = 22.dp, tint = status?.color ?: VentrovaColors.Muted)
                        Column(Modifier.weight(1f)) {
                            Text(stringResource(Res.string.opening_hours), style = bodyStyle(15.5.sp, FontWeight.SemiBold))
                            Text(stringResource(Res.string.opening_hours_today, hoursOnDay(hours, today)), style = bodyStyle(13.5.sp, color = VentrovaColors.Secondary))
                        }
                        VIcon(if (hoursOpen) Res.drawable.ic_expand_less else Res.drawable.ic_expand_more, size = 22.dp, tint = VentrovaColors.Faint)
                    }
                    if (hoursOpen) WeekHours(item, today, Modifier.padding(start = 16.dp, end = 16.dp, top = 6.dp))
                }

                val contacts = listOfNotNull(
                    place.address.formatted()?.let { Triple(Res.drawable.ic_location_on, it, null as (() -> Unit)?) },
                    place.phone?.let { Triple(Res.drawable.ic_call_filled, it, { actions.call(it) }) },
                    place.website?.let { Triple(Res.drawable.ic_language, displayUrl(it), { actions.openWebsite(it) }) },
                )
                if (contacts.isNotEmpty()) {
                    Column(
                        Modifier.padding(top = 24.dp).fillMaxWidth().clip(RoundedCornerShape(18.dp)).background(Color.White).padding(horizontal = 16.dp, vertical = 14.dp),
                        verticalArrangement = Arrangement.spacedBy(12.dp),
                    ) {
                        contacts.forEach { (icon, text, onClick) ->
                            Row(
                                Modifier.let { if (onClick != null) it.clickable(onClick = onClick) else it },
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(12.dp),
                            ) {
                                VIcon(icon, size = 22.dp, tint = VentrovaColors.Muted)
                                Text(text, style = bodyStyle(15.sp, color = if (icon == Res.drawable.ic_language) VentrovaColors.Accent else VentrovaColors.Ink))
                            }
                        }
                    }
                }
                Text(
                    buildAnnotatedString {
                        append(stringResource(Res.string.report_question) + " ")
                        withStyle(SpanStyle(color = VentrovaColors.Accent, fontWeight = FontWeight.SemiBold)) { append(stringResource(Res.string.report_action)) }
                    },
                    style = bodyStyle(13.5.sp, color = VentrovaColors.Muted),
                    textAlign = TextAlign.Center,
                    modifier = Modifier.padding(top = 14.dp).fillMaxWidth().clickable { model.viewModel.showMessage(AppMessage.Kind.NotAvailableYet) },
                )
            }
        }
    }
}

@Composable
private fun ActionTile(
    icon: DrawableResource,
    label: String,
    modifier: Modifier,
    dark: Boolean = false,
    enabled: Boolean = true,
    iconTint: Color = if (dark) Color.White else VentrovaColors.Ink,
    onClick: () -> Unit,
) {
    Column(
        modifier
            .height(62.dp)
            .clip(RoundedCornerShape(18.dp))
            .background(if (dark) VentrovaColors.Ink else VentrovaColors.Sand)
            .clickable(enabled = enabled, onClick = onClick)
            .padding(top = 2.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(4.dp, Alignment.CenterVertically),
    ) {
        val alpha = if (enabled) 1f else 0.35f
        VIcon(icon, size = 22.dp, tint = iconTint.copy(alpha = alpha))
        Text(label, style = bodyStyle(12.sp, FontWeight.SemiBold, (if (dark) Color.White else VentrovaColors.Ink).copy(alpha = alpha)))
    }
}

/** Body of the native filter sheet ("Clear" and close are native bar buttons). */
@OptIn(ExperimentalLayoutApi::class)
@Composable
internal fun CupertinoFilterContent(model: CupertinoModel) {
    CupertinoTheme(model) {
        val state by model.viewModel.state.collectAsState()
        val filters = state.filters
        val controls = LocalPlatformControls.current
        val viewModel = model.viewModel
        Column(
            Modifier.fillMaxWidth().background(VentrovaColors.Paper).windowInsetsPadding(WindowInsets.safeDrawing).verticalScroll(rememberScrollState()).padding(start = 18.dp, end = 18.dp, top = 8.dp, bottom = 18.dp),
        ) {
            Column(Modifier.fillMaxWidth().clip(RoundedCornerShape(22.dp)).background(Color.White).padding(start = 16.dp, end = 16.dp, top = 14.dp, bottom = 12.dp)) {
                Row(verticalAlignment = Alignment.Bottom) {
                    Text(stringResource(Res.string.filter_how_plant_based), style = bodyStyle(13.sp, FontWeight.SemiBold, VentrovaColors.Muted), modifier = Modifier.weight(1f))
                    Text(stopDescription(filters.strictness), style = bodyStyle(15.sp, FontWeight.SemiBold))
                }
                StrictnessSlider(filters.strictness, viewModel::setStrictness, Modifier.padding(top = 12.dp))
            }
            SectionTitle(stringResource(Res.string.filter_kind_of_place))
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                PlaceCategory.entries.forEach { category ->
                    val active = category in filters.categories
                    Row(
                        Modifier
                            .height(36.dp)
                            .clip(RoundedCornerShape(50))
                            .background(if (active) VentrovaColors.Ink else Color.White)
                            .border(0.5.dp, VentrovaColors.Ink.copy(alpha = 0.14f), RoundedCornerShape(50))
                            .clickable { viewModel.toggleCategory(category) }
                            .padding(start = 10.dp, end = 13.dp),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(6.dp),
                    ) {
                        val color = if (active) Color.White else VentrovaColors.Ink
                        VIcon(category.icon, size = 18.dp, tint = color)
                        Text(stringResource(category.label), style = bodyStyle(14.5.sp, FontWeight.Medium, color))
                        Text("${state.categoryCounts[category] ?: 0}", style = bodyStyle(14.5.sp, FontWeight.Medium, color.copy(alpha = 0.5f)))
                    }
                }
            }
            Row(
                Modifier.padding(top = 18.dp).fillMaxWidth().clip(RoundedCornerShape(18.dp)).background(Color.White).padding(horizontal = 14.dp, vertical = 10.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.dp),
            ) {
                VIcon(Res.drawable.ic_schedule, size = 22.dp, tint = VentrovaColors.Ink)
                Text(stringResource(Res.string.filter_open_now), style = bodyStyle(15.5.sp, FontWeight.SemiBold), modifier = Modifier.weight(1f))
                controls.Toggle(filters.openNow, { viewModel.toggleOpenNow() }, Modifier)
            }
            SectionTitle(stringResource(Res.string.filter_distance))
            controls.SegmentedControl(
                options = RadiusOptions.map { radiusLabel(it) },
                selectedIndex = RadiusOptions.indexOf(filters.radiusKm),
                onSelect = { viewModel.setRadius(RadiusOptions[it]) },
                modifier = Modifier.fillMaxWidth(),
            )
            Box(
                Modifier.padding(top = 20.dp).fillMaxWidth().height(54.dp).clip(RoundedCornerShape(50)).background(VentrovaColors.Ink).clickable { model.onCloseFilters() },
                contentAlignment = Alignment.Center,
            ) {
                Text(pluralStringResource(Res.plurals.filter_show_places, state.nearby.size, state.nearby.size), style = bodyStyle(17.sp, FontWeight.SemiBold, Color.White))
            }
        }
    }
}

@Composable
private fun SectionTitle(text: String) {
    Text(text, style = bodyStyle(13.sp, FontWeight.SemiBold, VentrovaColors.Muted), modifier = Modifier.padding(start = 4.dp, end = 4.dp, top = 18.dp, bottom = 8.dp))
}

/** Body of the native suggest sheet ("Cancel" and "Send" are native bar buttons). */
@OptIn(ExperimentalLayoutApi::class)
@Composable
internal fun CupertinoSuggestContent(model: CupertinoModel) {
    CupertinoTheme(model) {
        val state by model.viewModel.state.collectAsState()
        val form = state.suggestion
        val viewModel = model.viewModel
        if (form.sent) {
            Column(
                Modifier.fillMaxSize().background(VentrovaColors.Grouped).padding(start = 40.dp, end = 40.dp, bottom = 80.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
            ) {
                Box(Modifier.size(84.dp).background(LevelPalettes.Vegan.soft, CircleShape), contentAlignment = Alignment.Center) {
                    VIcon(Res.drawable.ic_check, size = 44.dp, tint = VentrovaColors.Accent)
                }
                Text(stringResource(Res.string.suggest_thanks), style = displayStyle(26), modifier = Modifier.padding(top = 20.dp))
                Text(stringResource(Res.string.suggest_thanks_body, form.name.trim()), style = bodyStyle(16.sp, color = VentrovaColors.Secondary), textAlign = TextAlign.Center, modifier = Modifier.padding(top = 8.dp))
                Box(
                    Modifier.padding(top = 28.dp).height(52.dp).clip(RoundedCornerShape(50)).background(VentrovaColors.Ink).clickable { model.onCloseSuggest() }.padding(horizontal = 40.dp),
                    contentAlignment = Alignment.Center,
                ) {
                    Text(stringResource(Res.string.suggest_done), style = bodyStyle(17.sp, FontWeight.SemiBold, Color.White))
                }
            }
            return@CupertinoTheme
        }
        Column(Modifier.fillMaxSize().background(VentrovaColors.Grouped).windowInsetsPadding(WindowInsets.safeDrawing).verticalScroll(rememberScrollState()).padding(start = 16.dp, end = 16.dp, top = 6.dp, bottom = 40.dp)) {
            Column(Modifier.fillMaxWidth().clip(RoundedCornerShape(22.dp)).background(Color.White)) {
                GroupedField(form.name, stringResource(Res.string.suggest_name)) { value -> viewModel.updateSuggestion { it.copy(name = value) } }
                HorizontalDivider(color = VentrovaColors.Ink.copy(alpha = 0.1f), thickness = 0.5.dp, modifier = Modifier.padding(start = 16.dp))
                GroupedField(form.address, stringResource(Res.string.suggest_address)) { value -> viewModel.updateSuggestion { it.copy(address = value) } }
            }
            GroupHeader(stringResource(Res.string.filter_kind_of_place))
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                PlaceCategory.entries.forEach { category ->
                    val active = form.category == category
                    Row(
                        Modifier
                            .height(38.dp)
                            .clip(RoundedCornerShape(50))
                            .background(if (active) VentrovaColors.Ink else Color.White)
                            .border(0.5.dp, VentrovaColors.Ink.copy(alpha = 0.12f), RoundedCornerShape(50))
                            .clickable { viewModel.updateSuggestion { it.copy(category = category) } }
                            .padding(start = 10.dp, end = 14.dp),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(6.dp),
                    ) {
                        val color = if (active) Color.White else VentrovaColors.Ink
                        VIcon(category.icon, size = 18.dp, tint = color)
                        Text(stringResource(category.label), style = bodyStyle(15.sp, FontWeight.Medium, color))
                    }
                }
            }
            GroupHeader(stringResource(Res.string.filter_how_plant_based))
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                VeganLevel.entries.forEach { level ->
                    val active = form.level == level
                    val palette = level.palette
                    Row(
                        Modifier.fillMaxWidth().clip(RoundedCornerShape(18.dp)).background(if (active) palette.soft else Color.White).clickable { viewModel.updateSuggestion { it.copy(level = level) } }.padding(horizontal = 14.dp, vertical = 12.dp),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(12.dp),
                    ) {
                        LevelGlyph(level, size = 18.dp, borderWidth = 3.dp)
                        Column(Modifier.weight(1f)) {
                            Text(stringResource(level.label), style = bodyStyle(15.5.sp, FontWeight.SemiBold))
                            Text(stringResource(level.description), style = bodyStyle(13.sp, color = VentrovaColors.Secondary))
                        }
                        VIcon(if (active) Res.drawable.ic_check_circle_filled else Res.drawable.ic_circle, size = 24.dp, tint = if (active) palette.color else VentrovaColors.Chevron)
                    }
                }
            }
            GroupHeader(stringResource(Res.string.suggest_what_is_vegan))
            Box(Modifier.fillMaxWidth().height(96.dp).clip(RoundedCornerShape(22.dp)).background(Color.White).padding(horizontal = 16.dp, vertical = 14.dp)) {
                if (form.note.isEmpty()) Text(stringResource(Res.string.suggest_note_placeholder), style = bodyStyle(16.sp, color = VentrovaColors.Faint))
                BasicTextField(form.note, { value -> viewModel.updateSuggestion { it.copy(note = value) } }, textStyle = bodyStyle(16.sp), cursorBrush = SolidColor(VentrovaColors.Accent), modifier = Modifier.fillMaxSize())
            }
            if (form.showError) {
                Text(stringResource(Res.string.suggest_error), style = bodyStyle(14.sp, color = VentrovaColors.Error), modifier = Modifier.padding(start = 16.dp, end = 16.dp, top = 12.dp))
            }
        }
    }
}

@Composable
private fun GroupHeader(text: String) {
    Text(text.uppercase(), style = bodyStyle(13.sp, color = VentrovaColors.Muted), modifier = Modifier.padding(start = 16.dp, end = 16.dp, top = 20.dp, bottom = 8.dp))
}

@Composable
private fun GroupedField(value: String, placeholder: String, onValue: (String) -> Unit) {
    Box(Modifier.fillMaxWidth().height(52.dp).padding(horizontal = 16.dp), contentAlignment = Alignment.CenterStart) {
        if (value.isEmpty()) Text(placeholder, style = bodyStyle(17.sp, color = VentrovaColors.Faint))
        BasicTextField(value, onValue, singleLine = true, textStyle = bodyStyle(17.sp), cursorBrush = SolidColor(VentrovaColors.Accent), modifier = Modifier.fillMaxWidth())
    }
}
